import React from 'react';
import './intro.scss';
import Vimeo from '../Vimeo/Vimeo';
import Panelists from '../Panelists/Panelists';
import { lang } from '../lang';

function Intro() {
  return (
    <section className="intro">
      <p>{lang.intro[0]}</p>
      <p>{lang.intro[1]}</p>
      <p>{lang.intro[2]}</p>
      <p>{lang.intro[3]}</p>
      <Vimeo />
      <p>{lang.intro[4]}</p>
      <Panelists />
      <p>{lang.intro[5]}</p>
    </section>
  );
}

export default Intro;
